<app-core-popup
  [header]="('case.case-features.header' | translate)"
  [dialogStyle]="{ width: '50vw' }"
  [saveText]="'common.save' | translate"
  (chooseOn)="sendSubmit()"
  #popup
>
@if(this.caseFeatures && this.caseFeatures.length>0){

<div class="hospital-form-container">
  <div class="form-tabs">
    <div class="tab-content">
      <div class="active-tab">
        <div class="form-fields" >
          <app-case-feature-inputs
            *ngFor="let item of caseFeatures"
            [item]="item"
          ></app-case-feature-inputs>
        </div>
      </div>
    </div>
  </div>

</div>
}@else if(!loading){
  <app-core-info-messages [message]="'Hiç Özellik yok'" [type]="'info'"></app-core-info-messages>

}

</app-core-popup>
<app-loading [fullScreen]="true" [loading]="loading"></app-loading>
